import _ from "lodash";
import client from "lib/apolloClient/client";
import { getAiUsageMetricsQuery } from "./AIFeedbackStripQueries";

export const getAiUsageMetricsQueryFromCache = variables => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getAiUsageMetricsQuery,
      variables,
    });
  } catch (e) {
    return {};
  }
  if (queryData != null) return _.get(queryData, "node", {});
  else return {};
};
